import { render, staticRenderFns } from "./item_status_select.vue?vue&type=template&id=e6ea2d02&"
import script from "./item_status_select.vue?vue&type=script&lang=js&"
export * from "./item_status_select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports